export default function getItemPartId(toc, itemId) {
  if (!toc || !itemId) {
    throw new ReferenceError('toc and itemId are mandatory');
  }

  const { children: parts } = toc;

  return parts.reduce((acc, part) => {
    const found = part.children.find((item) => item.id === itemId);
    return acc || (found ? part.id : undefined);
  }, undefined);
}
